import { format, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export const TZ_OFFSET_MS = 3 * 60 * 60 * 1000;

export function formatScore(value: number | null | undefined): string {
  return value === null || value === undefined ? '—' : value.toFixed(1);
}

export function formatPct(value: number | null | undefined, digits = 1): string {
  if (value === null || value === undefined) return '—';
  return `${value.toLocaleString('pt-BR', { maximumFractionDigits: digits })}%`;
}

export function formatDate(iso: string, pattern = 'dd/MM/yyyy'): string {
  return format(parseISO(iso), pattern, { locale: ptBR });
}

/** "14 Mai 2026" */
export function formatShortDate(iso: string): string {
  const s = format(parseISO(iso), 'dd MMM yyyy', { locale: ptBR });
  return s.replace(/ (\w)/, (_, c: string) => ` ${c.toUpperCase()}`);
}

export function initials(name: string): string {
  const parts = name.replace(/^Prof\.?\s+/i, '').trim().split(/\s+/);
  return ((parts[0]?.[0] ?? '') + (parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? '') : '')).toUpperCase();
}

/** YYYY-MM-DD no fuso local do navegador. */
export function toDateKey(d: Date): string {
  return format(d, 'yyyy-MM-dd');
}

const BRL = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 });

/** Valor em centavos → "R$ 13.430". */
export function formatBRL(cents: number | null | undefined): string {
  return cents === null || cents === undefined ? '—' : BRL.format(Math.round(cents / 100));
}

export function formatInt(value: number | null | undefined): string {
  return value === null || value === undefined ? '—' : value.toLocaleString('pt-BR');
}

/** "2026-09" → "set/26" */
export function formatMonthKey(key: string): string {
  const [y, m] = key.split('-').map(Number);
  return format(new Date(y!, (m ?? 1) - 1, 1), 'MMM/yy', { locale: ptBR });
}
